import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from './lib/AuthProvider';
import ErrorBoundary from './components/ErrorBoundary';
// Analytics provider removed
import App from './App';
import './index.css';

if (typeof window !== 'undefined') {
  // Keep these debug utilities available without pulling Firebase into the initial bundle.
  (window as any).setAdminClaimsForCurrentUser = async () => {
    const mod = await import('./utils/setAdminClaims');
    return mod.setAdminClaimsForCurrentUser();
  };
  (window as any).forceTokenRefresh = async () => {
    const mod = await import('./utils/refreshAdminClaims');
    return mod.forceTokenRefresh();
  };
}

// Initialize app without Firebase dependencies (Firebase will be loaded conditionally by FirebaseGuard)
const initApp = () => {
  try {
    const root = document.getElementById('root');
    if (!root) throw new Error('Root element not found');

    createRoot(root).render(
      <StrictMode>
        <ErrorBoundary>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ErrorBoundary>
      </StrictMode>
    );
  } catch (error) {
    console.error('Failed to initialize app:', error);
    const root = document.getElementById('root');
    if (root) {
      root.innerHTML = `
        <div style="color: red; padding: 20px; text-align: center;">
          <p>Failed to initialize application. Please refresh the page.</p>
          <button onclick="window.location.reload()" style="margin-top: 10px; padding: 8px 16px; background: #3b82f6; color: white; border: none; border-radius: 4px; cursor: pointer;">
            Refresh
          </button>
        </div>
      `;
    }
  }
};

// Start initialization
initApp();
